import {Cart} from '../Cart'
import {CartItem} from '../CartItem'

const $window = $(window)
global.cart = null

export function initCartManager() {
	$window.once('initCartManager').each(function () {
		const cartData = JSON.parse($('#data--cart').text())
		const items = cartData.items.map(item => {
			return new CartItem(item, item.quantity)
		})

		// noinspection JSUnresolvedVariable
		global.cart = new Cart(items)
	})
}